<template>
  <div style="position: relative; height: 210px">
    <chart-js :config="graphicChart" :width="900" :height="180"></chart-js>

    <v-menu v-for="(graphicStep, index) in graphicSteps" :key="graphicStep.sourceIndex"
            :disabled="! hasContent(graphicStep.step.waypoint)" :close-on-content-click="false" open-on-hover location="bottom">
      <template #activator="{ props }">
        <button type="button" class="pa-2 rounded-circle bg-surface position-absolute" :class="{ 'flex-center-center': ! graphicStep.step.mood, 'export-hidden': graphicStep.sourceIndex == 'new' }"
                :title="graphicStep.sourceIndex == 'new' ? $t('PROJECT_SHEET.WAYPOINT.ADD') : null"
                :style="graphicPointStyle(index, graphicStep)" style="width: 44px; height: 44px; transition: border-color .2s ease; z-index: 2"
                v-bind="props" @click="openGraphicStep(graphicStep.sourceIndex)">
          <span v-if="graphicStep.sourceIndex == 'new'"><v-icon color="primary">fas fa-plus</v-icon></span>
          <div v-else-if="graphicStep.step.mood" :class="`mood-icon-${graphicStep.step.mood}`"></div>
          <span v-else class="bg-midgrey rounded-circle" style="width: 10px; height: 10px;"></span>
        </button>
      </template>
      <v-card class="pa-2" style="max-width: 320px">
        <div class="quill-html" v-html="graphicStep.step.waypoint"></div>
      </v-card>
    </v-menu>

    <div v-for="(graphicStep, index) in graphicSteps" :key="`${graphicStep.sourceIndex}-label`"
         :style="{ left: `${graphicStepLeft(index)}%` }" :class="{ 'font-weight-bold': graphicStep.sourceIndex == currentStepIndex }"
         class="nobr pointer" style="position: absolute; bottom: 0; transform: translateX(-50%);"
         @click="openGraphicStep(graphicStep.sourceIndex)">
      {{ graphicStepDate(graphicStep.step) }}
    </div>
  </div>
</template>

<script>
  import ChartJs from '@/components/Reusables/ChartJs.vue';

  export default {
    components: {
      ChartJs,
    },
    props: {
      steps: { type: Object, required: true },
      currentStepIndex: { type: Number, default: 0 },
      displayMode: { type: String, default: 'graphic' },
    },
    emits: ['update:currentStepIndex', 'update:displayMode', 'add-step'],
    computed: {
      graphicSteps() {
        const steps = this.steps || [];
        return steps.slice(-5).map((step, index, lastSteps) => ({
          step,
          sourceIndex: steps.length - lastSteps.length + index,
        })).concat([{ step: { mood: steps[steps.length - 1]?.mood }, sourceIndex: 'new' }]);
      },
      graphicChart() {
        return {
          type: 'line',
          data: {
            labels: this.graphicSteps.map(item => this.graphicStepDate(item.step)),
            datasets: [{
              data: this.graphicSteps.map(item => this.graphicMoodValue(item.step)),
              borderColor: '#0d78ee',
              borderWidth: 3,
              borderCapStyle: 'round',
              borderJoinStyle: 'round',
              cubicInterpolationMode: 'monotone',
              backgroundColor: 'rgba(13, 120, 238, 0.12)',
              pointRadius: 0,
              pointHoverRadius: 0,
              tension: 0.45,
              fill: 'start',
            }],
          },
          options: {
            animation: false,
            maintainAspectRatio: false,
            responsive: true,
            layout: {
              padding: {
                left: 13,
                right: 14,
                top: 22,
                bottom: 20,
              },
            },
            plugins: {
              datalabels: {
                display: false,
              },
              legend: {
                display: false,
              },
              tooltip: {
                enabled: false,
              },
            },
            scales: {
              x: {
                display: false,
                grid: {
                  display: false,
                  drawBorder: false,
                },
                border: {
                  display: false,
                },
              },
              y: {
                min: 1,
                max: 4,
                display: false,
                grid: {
                  display: false,
                  drawBorder: false,
                },
                border: {
                  display: false,
                },
              },
            },
          },
        };
      },
    },
    methods: {
      graphicMoodValue(step) {
        const moodValues = { storm: 1, cloud: 2, suncloud: 3, sun: 4 };
        return moodValues[step.mood] || 2.5;
      },
      graphicPointStyle(index, graphicStep) {
        const isActive = graphicStep.sourceIndex == this.currentStepIndex;
        return {
          border: isActive ? '1px solid rgba(var(--v-theme-success), 1)' : '1px solid rgba(var(--v-theme-on-surface), 0.12)',
          left: `calc(${this.graphicStepLeft(index)}% - 22px)`,
          top: `calc(${this.graphicStepTop(graphicStep.step)}% - 22px)`,
        };
      },
      graphicStepDate(step) {
        return step.date ? moment(step.date).format('DD/MM') : '';
      },
      graphicStepLeft(index) {
        if (this.graphicSteps.length <= 1) return 50;
        return 4.2 + index / (this.graphicSteps.length - 1) * 91.6;
      },
      graphicStepTop(step) {
        const value = this.graphicMoodValue(step);
        return 9.1 + (4 - value) / 3 * 66.7;
      },
      openGraphicStep(index) {
        if (index === 'new') {
          this.$emit('add-step');
          return;
        }
        this.$emit('update:currentStepIndex', index);
        this.$emit('update:displayMode', 'text');
      },
      hasContent(html) {
        return !! window.html2text(html || '').trim();
      },
    },
  };
</script>
